import { useSmartPlansQuery } from './gql/graphql.v3.generated';

export const useSmartPlans = () => {
  const { data, loading } = useSmartPlansQuery({
    context: {
      batch: true,
    },
  });

  return {
    plans: data?.smartInfo.plans || [],
    loading,
  };
};
